import { CategoryType } from "@/types/category";

const CATEGORY_RELATION_KEYS = [
  "categories",
  "categorys",
  "category_Forms",
  "category_Roles",
  "category_Workflows",
  "category_MenuElements",
  "category_Entities"
];

const normalizeCategory = (value: any): CategoryType | null => {
  if (!value) {
    return null;
  }

  const categoryValue = value.category ?? value.Category ?? value;
  const id = Number(
    categoryValue.id ??
      categoryValue.Id ??
      value.categoryId ??
      value.CategoryId ??
      0
  );
  const name = String(
    categoryValue.name ??
      categoryValue.Name ??
      value.categoryName ??
      value.CategoryName ??
      ""
  ).trim();

  if (!id || !name) {
    return null;
  }

  return {
    id,
    name,
    description: String(
      categoryValue.description ??
        categoryValue.Description ??
        value.description ??
        value.Description ??
        ""
    ).trim()
  };
};

export const extractCategories = (value: unknown): CategoryType[] => {
  if (!value || typeof value !== "object") {
    return [];
  }

  const record = value as Record<string, any>;

  for (const key of CATEGORY_RELATION_KEYS) {
    const relationValue = record[key];
    if (Array.isArray(relationValue)) {
      const categories = relationValue
        .map((item) => normalizeCategory(item))
        .filter((item): item is CategoryType => Boolean(item));

      if (categories.length > 0) {
        return categories;
      }
    }
  }

  return [];
};

export const getCategoryIds = (value: unknown) =>
  extractCategories(value).map((category) => category.id);

export const formatCategoryNames = (value: unknown) =>
  extractCategories(value)
    .map((category) => category.name)
    .filter(Boolean)
    .join(" و ");
